<template>
  <ul class="wrapper__submenu__wrapper">
    <li v-for="item in subitem" :key="item.id"
    @click.stop="select(item)" class="wrapper__submenu__wrapper__item"
    :class="{selected: item.value == value}">{{item.label}}</li>
  </ul>
</template>

<script>

export default {
  name: 'adx-sub-filter',
  components: {

  },
  props: {
    subitem: {
      required: false
    },
    parent: {
      required: false
    },
    value: {
      required: false
    }
  },
  data() {
    return {
      selected: null
    }
  },
  computed: {

  },
  watch: {
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    select(item) {
      this.$emit('select', item, this.parent)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>